import { CalendarForm } from "./CalendarForm";

const Calendar = () => {
  return <CalendarForm />;
};

export { Calendar };
